import { render } from "./uploadZBApproval.vue?vue&type=template&id=ecdbf5f6&scoped=true"
import script from "./uploadZBApproval.vue?vue&type=script&lang=js"
export * from "./uploadZBApproval.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecdbf5f6"]])

export default __exports__